import script from "./categoryTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./categoryTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./categoryTemplate.vue?vue&type=style&index=0&id=dd29ea4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd29ea4e"]])

export default __exports__